import { render, staticRenderFns } from "./MockSelection.vue?vue&type=template&id=67ef90bc&scoped=true"
import script from "./MockSelection.vue?vue&type=script&lang=js"
export * from "./MockSelection.vue?vue&type=script&lang=js"
import style0 from "./MockSelection.vue?vue&type=style&index=0&id=67ef90bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef90bc",
  null
  
)

export default component.exports